// Theme configuration for styled-components
const theme = {
  green: '#30d403',
  black: '#393939',
  white: '#EDEDED',
};

export default theme;